export const certificateObj = [
    {Icon: require("../../images/Certificates/React_JS.jpg"),alt:'React JS Certificate'},
    {Icon: require("../../images/Certificates/Node_JS.jpg"),alt:'Node JS Certificate'},
    {Icon: require("../../images/Certificates/Mongo_DB.jpg"),alt:'Mongo DB Certificate'},
    {Icon: require("../../images/Certificates/JavaScript.jpg"),alt:'JavaScript Certificate'},
    {Icon: require("../../images/Certificates/HTML5.jpg"),alt:'HTML5 Certificate'},
    {Icon: require("../../images/Certificates/Cloud_Computing.jpg"),alt:'Cloud_Computing Certificate'},
    {Icon: require("../../images/Certificates/DevOps.jpg"),alt:'DevOps Certificate'},
    {Icon: require("../../images/Certificates/Agile.jpg"),alt:'Agile Certificate'},
    {Icon: require("../../images/Certificates/Python.jpg"),alt:'Python Certificate'},
    {Icon: require("../../images/Certificates/Software_Engineering.jpg"),alt:'Software_Engineering Certificate'}
]